module.exports = __webpack_public_path__ + "img/ylb-12.7a880f15.png";